export enum REWARD_SECTIONS_Z_INDEXES {
  IMAGE_SECTION = 1,
  SCROLLABLE_CONTENT_SECTION = 2,
  HEADER_AND_FOOTER = 3,
}

export const IMAGE_PLACEHOLDER_HEIGHT = 273;
export const CONTENT_BORDER_RADIUS = 8;
